interface Disclaimers {
  creditMultiCardDisclaimer: string | null;
  debitMultiCardDisclaimer: string | null;
  changeAddressDisclaimer: string;
  checkOrderDisclaimer: string;
  creditCardPINDisclaimer: string | null;
  crossCurrencyDisclaimer: string;
  debitCardPINDisclaimer: string | null;
  internationalDraftAutomatedOrderDisclaimer: string | null;
  internationalDraftOrderDisclaimer: string;
  localDraftAutomatedOrderDisclaimer: string | null;
  localDraftOrderDisclaimer: string;
  remoteDepositDisclaimer: string;
  stolenCardDisclaimer: string;
  topupTransactionDisclaimer: string;
  transactionDisclaimer: string;
}

export interface ExternalLinks {
  link1: string;
  link2: string;
  name1: string;
  name2: string;
}

interface Permissions {
  code: number;
  description: string;
}

interface AlertDeliveryMethod {
  alertEmailEnabled: boolean;
  alertPushEnabled: boolean;
  alertTextEnabled: boolean;
}

interface MultifactorDeliveryMethod {
  multifactorEmailEnabled: boolean;
  multifactorPushEnabled: boolean;
  multifactorTextEnabled: boolean;
}

interface SecondaryMultifactorDeliveryMethod {
  secondaryMultifactorEmailEnabled: boolean;
  secondaryMultifactorPushEnabled: boolean;
  secondaryMultifactorTextEnabled: boolean;
}

interface TimeZone {
  timeZoneName: string;
  id: number;
  timeZoneDeliveryTime: string;
  timeZoneDeliveryTimeValue: string;
  timeZoneLocationDesc: string;
}

interface Profile {
  alertDeliveryMethod: AlertDeliveryMethod;
  alias: string;
  avatarThumbnail: null;
  branchCode: string;
  branchId: string;
  branchName: string;
  dateAndTimeLastLogin: string;
  dateLastLogin: string;
  email: string;
  email2: string | null;
  firstName: string;
  isValidCif: boolean;
  language: string;
  lastName: string;
  marketingSubscribe: boolean;
  mfaDestination: number; // map the tfaDestination 
  alterDestination: number; // map the tfaSecondaryDestination Be careful in users table there is a another column names alertDestination (vs alterDestination)
  mobileNumber: string;
  mobileNumber2: string | null;
  mobilearthId: string;
  multifactorDeliveryMethod: MultifactorDeliveryMethod;
  secondaryMultifactorDeliveryMethod: SecondaryMultifactorDeliveryMethod;
  networkDescription: string;
  networkId: string;
  textMessageEnable: boolean;
  timeZone: TimeZone;
  userType: number;
  username: string;
  isCompanyAdmin: boolean,
  isCompanyUser: boolean,
  isCorporateBillPayUser: boolean,
}

interface InternalSettings {
  disclaimers: Disclaimers;
  externalLinks: ExternalLinks;
  notifications: boolean;
  permissions: Permissions[];
  profile: Profile;
  bankOrCreditUnion: string;
}

export { InternalSettings, Permissions, Profile, Disclaimers };

export enum PermissionList {
  ALL = -1,
  BUDDY_PAY_BY_TEXT = 55113,
  MERCHANT_PAY_BY_TEXT = 55002,
  ACCESS_ACCOUNT_LISTING = 60000,
  ACCESS_INTERNAL_TRANSACTION = 53505,
  ACCESS_EXTERNAL_TRANSACTION = 53100,
  ACCESS_CROSS_CURRENCY_TRANSACTION = 53301,
  ACCESS_ACCOUNT_VIEW_MAINTENANCE = 60004,
  CREATE_CURRENCY_EXCHANGE = 900140,
  ACCESS_ACCOUNT_HISTORY = 61000,
  ACCESS_WRITER_HISTORY_DOWNLOAD = 62100,
  ACCESS_WRITER_HISTORY_EMAIL = 62101,
  ACCESS_ALERT = 52000,
  ACCESS_ALERT_DESTINATION_CHANGE = 54050,
  ACCESS_MFA_DESTINATION_CHANGE = 54052,
  ACCESS_ALERT_ENABLE = 52001,
  ACCESS_ALERT_DISABLE = 52002,
  ACCESS_ALERT_TEXT_ME_ENABLE = 56000,
  ACCESS_INTERNAL_TRANSACTION_BY_TEXT_ACCESS = 53507,
  ACCESS_PDF_STATEMENTS_DOWNLOAD = 900190,
  ACCESS_EXTERNAL_STATEMENTS = 54091,
  TRANSFER_BY_TEXT_CREATE = 53501,
  TRANSFER_BY_TEXT_UPDATE = 53502,
  TRANSFER_BY_TEXT_DELETE = 53503,
  ACCESS_PASSWORD_CHANGE = 54000,
  ACCESS_LANGUAGE_CHANGE = 54010,
  ACCESS_EMAIL_CHANGE = 54030,
  ACCESS_ID_CHANGE = 54035,
  ACCESS_MANAGE_USER_GROUPS = 54036,
  ACCESS_TIME_ZONE_CHANGE = 54040,
  ACCESS_TEXT_ME_CHANGE = 54060,
  ACCESS_SUBSCRIBE_CHANGE = 54070,
  VIEW_TRUSTED_DEVICE = 54080,
  ACCESS_BILL_PAY_PERFORM_HISTORY = 55200,
  ACCESS_BILL_PAY_PERFORM_MAINTAIN_MERCHANT = 55100,
  ACCESS_BILL_PAY_PERFORM_MAINTAIN_MERCHANT_CREATE = 55101,
  ACCESS_BILL_PAY_PERFORM_MAINTAIN_MERCHANT_UPDATE = 55102,
  ACCESS_BILL_PAY_PERFORM_MAINTAIN_MERCHANT_DELETE = 55103,
  ACCESS_BUDDY_LIST = 63300,
  ACCESS_PAY_PERFORM_BUDDY_CREATE = 55110,
  ACCESS_PAY_PERFORM_BUDDY_UPDATE = 55111,
  ACCESS_PAY_PERFORM_BUDDY_DELETE = 55112,
  LIST_ORDERS = 60002,
  VIEW_ORDER_DETAILS = 53300,
  ACCESS_MOBILEARTH_TOPUP = 55131,
  CREATE_CASH_ORDER = 53325,
  CREATE_CHEQUE_ORDER = 53315,
  CREATE_DRAFT_ORDER = 53415,
  CREATE_DRAFT_AUTOMATED_ORDER = 53417,
  CREATE_PEER_QR_CODE = 55401,
  SCAN_PEER_QR_CODE = 55402,
  CREATE_ORDER_QR_CODE = 55403,
  SCAN_ORDER_QR_CODE = 55404,
  CREATE_EXTERNAL_EFT_QR_CODE = 55405,
  SCAN_EXTERNAL_EFT_QR_CODE = 55406,
  SCAN_MERCHANT_QR_CODE = 55411,
  CREATE_EFT_ORDER = 900210,
  CREATE_BANK_TRANSFER = 900400,
  CREATE_WIRE_ORDER_STANDARD = 900170,
  CREATE_WIRE_TRANSFER_TEMPLATE = 53425,
  MODIFY_WIRE_TRANSFER_TEMPLATE = 53428,
  DELETE_WIRE_TRANSFER_TEMPLATE = 53431,
  ACCESS_GROUP_PAY = 56100,
  MOBIBRANCH_CUSTOMER_ACCESS = 900180,
  MANAGE_NOTIFICATION_TOKENS = 920000,
  RESET_PUSH_TOKENS = 920001,
  PAYROLL_ACCESS_BATCHES_SCREEN = 56200,
  PAYROLL_VIEW_BATCH = 56201,
  PAYROLL_CREATE_UPDATE_BATCH = 56202,
  PAYROLL_DELETE_BATCH = 56204,
  PAYROLL_UPLOAD_BATCHES = 56205,
  PAYROLL_POST = 56206,
  PAYROLL_CREATE_UPDATE_DEPARTMENTS_GROUP = 56101,
  PAYROLL_DELETE_DEPARTMENT_GROUPS = 56103,
  ACCESS_LITE_APPLICATIONS = 900500,
  SERVICE_ACESS_GROUP = 57300,
  SERVICE_CREATE_CHANGE_ADDRESS = 57321,
  SERVICE_REPORT_LOST_CREATE = 57322,
  VIEW_SERVICE_REQUEST = 55501,
  SERVICE_REQUEST_CREATE = 55502,
  VIEW_SMART_FORMS = 55510,
  CREATE_SMART_FORMS = 55511,
  SECURE_MESSAGE = 57340,
  NO_SECURE_MESSAGES = 2539,
  VOUCHER_MODULE = 900130,
  CHEQUE_IMAGE_MODULE = 57330,
  PENDING_TRANSACTION_INITIATOR_CANCEL = 53202,
  PENDING_TRANSACTION_APPROVER_REJECT = 53205,
  PENDING_TRANSACTION_APPROVER_APPROVE = 53206,
  MAKE_BILL_PAYMENT_FOR_CUSTOMER = 900306,
  ACCESS_SCHEDULED_PAYMENTS = 900350,
  CREATE_SCHEDULED_PAYMENTS = 900351,
  UPDATE_SCHEDULED_PAYMENTS = 900352,
  DELETE_SCHEDULED_PAYMENTS = 900353,
  MANAGE_PAYEES = 900390,
  PERFORM_ONLINE_DOMESTIC_PAYMENT = 900391,
  MANAGE_ORDER_TEMPLATES = 53432,
  MOBILEARTH_ACCESS_CUSTOMER_STOP_PAYMENT_VIEW = 57311,
  MOBILEARTH_ACCESS_CUSTOMER_STOP_PAYMENT_CREATE = 57312,
  MOBILEARTH_ACCESS_MAKE_PAYMENT_MERCHANT = 55001,
  MOBILEARTH_ACCESS_MAKE_PAYMENT_PEER = 55114,
  MOBILEARTH_ACCESS_MAKE_PAYMENT_ONE_TIME = 55104,
  MOBILEARTH_ACCESS_MAKE_MOBILEARTH_TOPUP_PAYMENT = 55132,
  MOBILEARTH_ACCESS_TOPUP_SUBMITTED_REPORT = 921000,
  MOBILEARTH_ACCESS_CREDIT_CARD_PERFORM_PIN_CHANGE = 59001,
  ACCESS_ACCOUNT_FLOATS = 58000,
  ACCESS_ACCOUNT_HOLDS = 58100,
  ACCESS_ALIAS_CHANGE = 900920,
  SCHEDULE_ORDERS = 900355,
  UPLOAD_BATCH_ORDERS = 904000,
  VIEW_BATCH_ORDER_SUMMARY = 904001,
  ACCESS_MANAGE_USER_ADMIN = 920925,
  MOBILEARTH_ACCESS_CUSTOMER_ACCESS_CREDIT_CARDS_LIST = 59002,
  MOBILEARTH_ACCESS_CUSTOMER_ACCESS_MANAGE_CREDIT_CARDS = 59003,
  MOBILEARTH_ACCESS_CUSTOMER_ACCESS_DEBIT_CARDS_LIST = 59010,
  MOBILEARTH_ACCESS_CUSTOMER_ACCESS_MANAGE_DEBIT_CARDS = 59011,
  MOBILEARTH_ACCESS_CUSTOMER_ACTIVATE_DEBIT_CARD_BY_PIN = 59015,
  MOBILEARTH_ACCESS_CUSTOMER_RESET_DEBIT_CARD_PIN = 59016,
  MOBILEARTH_ACCESS_CUSTOMER_ACCESS_LOANS_TO_PRINCIPAL = 59020,
  ACCESS_LIVE_CHAT = 900320,
  ACCESS_RESOURCES = 900200,
  CREATE_MOBILE_DEPOSIT_REQUEST = 80000,
  ACCESS_MOBILE_DEPOSIT_HISTORY = 80100,
  VIEW_MOBILE_DEPOSIT_HISTORY_INFO = 80101,
  VIEW_MOBILE_DEPOSIT_HISTORY_IMAGE_INFO = 80102,
  ACCESS_REMOTE_DEPOSIT_SERVICE = 80103,
  REMOTE_DEPOSIT_RESULT_VIEW = 80104,
  MOBILEARTH_ACCESS_PFM_INSIGHT = 58500,
  MOBILEARTH_ACCESS_PFM_GOAL = 58503,
  MOBILEARTH_ACCESS_VOICE_COMMAND = 58504,
  MOBILEARTH_ACCESS_FINANCIAL_OFFERS = 58506,
  ACCESS_MANAGE_VIZ_PAYEES = 58509,
  ACCESS_MAKE_VIZ_SEND_MONEY_TRANSACTION = 58510,
  ACCESS_DEACTIVATE_VIZ_ALIAS = 58511,
  ACCESS_REACTIVATE_VIZ_ALIAS = 58512,
  ACCESS_SET_VIZ_CARD_PREFERENCE = 58513,
  ACCESS_VIZ_SEND_MONEY_HISTORY = 58514,
}